import { push } from 'react-router-redux';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { routes } from '../../../../constants';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { RESOURCES, USER_RESOURCE_ENDPOINT } from './endpoints';
import getQualifications from './getQualifications';

const actions = createActions({
  USER: {
    ADD_QUALIFICATION: (qualification, files) => ({ qualification, files }),
    API: {
      ADD_QUALIFICATION: apiResourceActionCreator('qualifications')
    }
  }
})

export const apiAction = (authToken, formData) => commonApiActions.authenticated.postFormData(USER_RESOURCE_ENDPOINT(RESOURCES.Qualification), authToken, formData, actions.user.api.addQualification)

export function* addQualification(action) {
  const authToken = yield select(authTokenSelector);

  if (authToken.idToken) {
    const formData = {
      data: action.payload.qualification,
      file: action.payload.files
    }
    yield put(apiAction(authToken, formData));

    const result = yield apiActionResult(actions.user.api.addQualification);
    if (result.success) {
      yield put(getQualifications.action.user.getQualifications());
      yield put(push({ pathname: routes.app.professionalProfile.root }))
    }
  }
}

const configuration = {
  name: 'addQualification',
  action: actions,
  sagas: addQualification,
  reducers: {
    request: (state, action) => ({
      ...state,
      isUpdating: true
    }),
    success: (state, action) => ({
      ...state,
      isUpdating: false
    }),
    failed: (state, action) => ({
      ...state,
      isUpdating: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/addQualification.js